<template>
  <div>
    <!-- 附加服务数量异常 -->
    <el-dialog :title="$t('message.theNumberOfAdditionalServicesIsAbnormal')" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <div class="row" v-for="(item, index) in prompt" :key="index">
          <span>
            {{ item }}番
          </span>
          附加服务数量与下单数量不等，请注意！
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("message.ok")
        }}</el-button>
        <el-button type="primary" @click="copyContent" class="primary">{{
          $t("message.copy")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {

  data() {
    return {
      dialogVisible: false,
      prompt: [],
    };
  },
  methods: {
    promptDetection(list) {
      this.prompt = []
      list.forEach(item => {

        if (item.option != null) {
          let flag = item.option.every(items => items.num == item.num)
          if (!flag) {
            this.prompt.push(item.sorting)
          }
        }

      })
      if (this.prompt != false) {
        this.dialogVisible = true
      }
    },
    // 复制
    copyContent() {
      let val = ''
      this.prompt.forEach(item => {
        val += `${item}番， 附加服务数量与下单数量不等，请注意！\n`
      })
      this.copy(val)
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  max-height: 600px;
  overflow-y: auto;

  .row {
    margin-bottom: 20px;
    font-size: 16px;

    span {
      font-size: 18px;
      font-weight: bold;
      color: #b4272d
    }
  }
}
</style>